import React, { createContext, useState, useCallback, useContext } from 'react';
import { toast } from 'react-toastify';
import { TokenContext } from './TokenContext';
import {  apiProgramaMercado } from '../services/api';
import PayloadConciliacao from '../assets/styles/payloadsConciliacaoExcel/payloadConciliacao.json';



export const ConciliacaoContext = createContext([]);

export function ConciliacaoProvider(props) {
	const { children, user } = props;
	const [loadingConciliacao, setLoadingConciliacao] = useState(false);

	const [conciliacaoData, setConciliacaoData] = useState([]);
	const [vendasMesAterior, setVendasMesAterior] = useState(0);
	const { autenticacaoV1Token } = useContext(TokenContext);
	async function authToken() {
		let result = null;
		try {
			result = await autenticacaoV1Token();
		} catch (e) {
			console.error(e);
		}
		return result;
	}
	/*
	async function authToken() {
		try {
			const credentials = {
				username: config.USER_AUTHENTICATION_DEV,
				password: config.USER_AUTHENTICATION_PASS_DEV,
			};
			const response = await apiLucree.post(
				'autenticacao/v1/',
				credentials
			);

			return response;
		} catch (error) {
			toast.error(
				'Os dados de autenticação de token não foram carregados. Por favor atualize a página'
			);
		}

		return null;
	}
	*/
	function download(data) {
		var oReq = new XMLHttpRequest();
		oReq.open(
			'POST',
			'https://api.grupoe2f.com.br/export/export',
			true
		);
		oReq.responseType = 'blob';
		oReq.setRequestHeader('Content-Type', 'application/json');

		const link = document.createElement('a');

		oReq.onload = function () {
			var blob = oReq.response;

			var contentType = oReq.getResponseHeader('Content-Type');

            if (contentType && contentType.indexOf('application/json') !== -1) {
                try {
                    var jsonResponse = JSON.parse(oReq.responseText);

                    if (jsonResponse && jsonResponse.erro) {
                        toast.error(`Nenhuma liquidação encontrada` );
						setLoadingConciliacao(false);
                        return;
                    }
                } catch (error) {
                    toast.error('Nenhuma liquidação encontrada');
						setLoadingConciliacao(false);
                    return;
                }
            }


			link.setAttribute('download', 'ConciliacaoLucree.xlsx');
			link.href = URL.createObjectURL(blob);
			link.setAttribute('href', URL.createObjectURL(blob));
			document.body.appendChild(link);
			link.click();
			toast.success('Download Concluído');
			setLoadingConciliacao(false);
		};

		oReq.send(JSON.stringify(data));
	}

	const getExport = useCallback(
		 async (pagina, dataRange, params) => {
			setLoadingConciliacao(true)
			try {
				const dataPath = '.data';
				let url = '';

				url = `https://7g9u0rzwg4.execute-api.us-west-2.amazonaws.com/prod/api-programa-mercado/conciliacao`;

				const payload = {
					logo: 'lucree',
					sheet_name: 'Planilha Lucree',
					request: {
						data_path: dataPath,
						url: url,
						headers: {
							Authorization: `Bearer ${user.token.access}`,
						},
						params: {
							items: 5000,
							data_inicio: params.dateInit,
							data_fim: params.dateEnd,
							cupom_fiscal: 5,
							documento: user.dados.documento
						  },
					},
					styles: [
						{
							name: "bold",
							bold: true
						},
						{
							name: "date",
							num_format: "DD/MM/YYYY"
						},
						{
							name: "money",
							num_format: "#,##0.00;[RED]-#,##0.00"
						}
					],
					format: PayloadConciliacao,
				};
				download(payload);
			} catch (error) {
				setTimeout(() => setLoadingConciliacao(false), 3000)
				console.log('Erro no Download Export, extrato.');
			}
		}
	);

	async function getConciliacaoData(params) {
		setLoadingConciliacao(true)
		try {
			await apiProgramaMercado.get(`conciliacao`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,

					},
					params: {
						data_inicio: params.dateInit,
						data_fim: params.dateEnd
					},
				}).then((res) => {
					if(res.data.dados.saldo_mes_anterior){
						setVendasMesAterior(res.data.dados.saldo_mes_anterior)
					}
					
					if(res.data.dados.conciliacoes.length === 0){
						setConciliacaoData([])
					} else {
						setConciliacaoData(res.data.dados.conciliacoes);
					}
					setLoadingConciliacao(false);
				})
		} catch (error) {
			setConciliacaoData([])
			setLoadingConciliacao(false)
		}
		return null;
	}

	async function getRecebimentosFuturos() {
		try {
			return await apiProgramaMercado.get(`recebimentos-futuros`,
				{
					headers: {
						'Content-Type': 'application/json',
						Authorization: `Bearer ${user.token.access}`,

					},
				})
		} catch (error) {
			let msg = "Não foi possível localizar os recebimentos futuros."

			if(error.response.data.message){
				msg = error.response.data.message;
			}

			toast.error(msg);
			
			return null;
		}
	}

	return (
		<ConciliacaoContext.Provider
			value={{
				authToken,
				getRecebimentosFuturos,
				loadingConciliacao,
				getConciliacaoData,
				vendasMesAterior,
				setLoadingConciliacao,
				conciliacaoData,
				getExport
			}}>
			{children}
		</ConciliacaoContext.Provider>
	);
}
